import { Box, Typography } from "@mui/material";
import { InvitationCollaborateProject } from "../../db_access/invitation_collaborate_project";
import ButtonAccept from "./ButtonAccept";
import ButtonReject from "./ButtonReject";

const InvitationProject = ({ invitation, setRefresh, showAction = true, isReceiverPOV = true }) => {
  return (
    <Box sx={{ display: "flex" }}>
      <Box sx={{ flex: 1, display: "flex", flexDirection: "column", gap: 0.5, paddingX: 1 }}>
        <Box sx={{ display: isReceiverPOV ? "block" : "none" }}>
          <Typography sx={{ textAlign: "left", fontFamily: "Poppins", fontWeight: 100 }}>
            <Box component={"span"} sx={{ color: "black" }}>
              {invitation.sender_name}
            </Box>{" "}
            invites you to collaborate on Project:{" "}
            <Box component={"span"} sx={{ color: "black" }}>
              {invitation.project_name}
            </Box>
          </Typography>
        </Box>
        <Box sx={{ display: isReceiverPOV ? "none" : "block" }}>
          <Typography
            sx={{
              textAlign: "left",
              fontFamily: "Poppins",
              fontWeight: invitation.is_read ? 100 : 500,
            }}>
            <Box component={"span"} sx={{ color: "black" }}>
              {invitation.username}
            </Box>{" "}
            invites you to collaborate on{" "}
            <Box component={"span"} sx={{ color: "black" }}>
              {invitation.collaborate_name}
            </Box>
          </Typography>
        </Box>
        <Box sx={{ display: "flex", gap: 0.5 }}>
          <Box
            sx={{
              display: showAction && invitation.status === "Pending" ? "block" : "none",
            }}>
            <ButtonAccept invitation_id={invitation.id} setRefresh={setRefresh} request={InvitationCollaborateProject.accept} />
          </Box>
          <Box
            sx={{
              display: showAction && invitation.status === "Pending" ? "block" : "none",
            }}>
            <ButtonReject invitation_id={invitation.id} setRefresh={setRefresh} request={InvitationCollaborateProject.reject} />
          </Box>
          <Box
            sx={{
              display: !showAction || invitation.status !== "Pending" ? "block" : "none",
            }}>
            <Typography
              sx={{
                textAlign: "left",
                fontFamily: "Poppins",
                fontWeight: invitation.is_read ? 100 : 500,
              }}>
              {invitation.status}
            </Typography>
          </Box>
        </Box>
      </Box>
      <Box>
        <Typography sx={{ fontFamily: "Poppins", fontWeight: 100 }}>Created At:{invitation.timestamp.split(" GMT")[0]}</Typography>
        <Typography sx={{ fontFamily: "Poppins", fontWeight: 100 }}>Last Modified:{invitation.timestamp.split(" GMT")[0]}</Typography>
      </Box>
    </Box>
  );
};

export default InvitationProject;
